import PropTypes from 'prop-types';
import React from 'react';
import CustomerForm from '../../CustomerForm';
import Modal from '../../../Modal';

const AddCustomerModal = ({ close, onSubmit }) => (
  <Modal
    title="Add new client"
    close={close}
  >
    <div className="u-pv+ u-ph++">
      <CustomerForm submitButtonText="Add client" onSubmit={onSubmit} />
    </div>
  </Modal>
);
AddCustomerModal.propTypes = {
  close: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AddCustomerModal;
